<template>
    <div
        class="applicable-discount-tile"
        :class="{ 'not-available': !isAvailable }"
        @click="onClick"
        @touchstart="onTouchStart"
        @touchend="onTouchEnd"
    >
        <span class="item-name">{{ getNameInLocationLanguage(item, true) }} </span>
        <div class="item-color"></div>
    </div>
</template>

<script setup lang="ts">
    import { useTapRecognizer } from "@/components/composables/useTapRecognizer";
    import type { IDiscount } from "@/data/model/Discount";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";

    // define properties
    const props = defineProps<{
        item: IDiscount;
        isAvailable: boolean;
    }>();

    const emit = defineEmits<{
        discountSelected: [item: IDiscount];
    }>();

    const { onTouchStart, onTouchEnd } = useTapRecognizer({
        onTap: (_, e) => {
            const isOpenPopoverBtn = (e.target as any)?.className?.includes("open-popover-btn");
            if (!isOpenPopoverBtn) {
                e.preventDefault();
                onClick();
            }
        },
        toleranceX: 40,
        toleranceY: 20,
        shouldPreventDefault: false,
    });

    function onClick() {
        emit("discountSelected", props.item);
    }
</script>

<style scoped lang="scss">
    @use "./../../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../../assets/styles/scss/shared/_mixins.scss";

    .applicable-discount-tile {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100px;
        padding: 0.25em;
        background: white;
        border: 1px solid #dcdcdc;
        border-radius: 0.25em;
        color: colors.$fontColor;
        font-size: 18px;
        cursor: pointer;
        transition: 0.2s linear;

        @include mixins.hover-and-active() {
            color: colors.$fontColorHover;
            background-color: #ddd;
            border-color: #bbb;
        }

        > .item-name {
            font-weight: 600;
            color: colors.$fontColor;
            text-align: center;
            word-break: break-word;
        }

        .item-color {
            position: absolute;
            bottom: 0;
            height: 5px;
            left: 0;
            right: 0;
            // background-color: colors.$orange;
            background-color: #777;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }

        &.not-available {
            cursor: default;
            background-color: #f7f7f7 !important;
            border-color: #dcdcdc !important;

            .item-name {
                color: #bbb;
            }

            i {
                position: absolute;
                top: 0.5em;
                right: 0.5em;
                color: #ccc !important;
            }

            .item-color {
                display: none;
            }
        }
    }
</style>
